export enum FlagsAuth {
  ADMIN = 'ADMIN',
}

